import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React, { useContext, useEffect } from 'react';
import _isEmtpy from 'lodash/isEmpty';
import Masonry from 'react-masonry-css';
import { BREAKPOINT_COLS, TABLET_BREAKPOINT, MOBILE_BREAKPOINT } from './MasonryAccordionLinks.constants';
import { getDelay } from './MasonryAccordionLinks.utils';
import useResponsive from '../../../../../../../../hooks/use-responsive/use-responsive';
import { SiteNavigationLinkPropType } from '../../../../../../../../services/proptypes';
import SlideReveal from '../../../../../../../animations/components/Reveal/variants/SlideReveal/SlideReveal';
import { NavigationContext } from '../../../../Navigation.context';
import { generateKey } from '../../../Links/Links.utils';
import { ITEM_NAVIGATION_MODE } from '../../PopupAccordionMenuLink.constants';
import { NavigationModePropType } from '../../PopupAccordionMenuLink.types';
import AccordionLinks from '../AccordionLinks';
import { MAX_LINKS_TO_SHOW } from '../AccordionLinks/AccordionLinks.constants';
import { ACCORDION_REVEAL_ANIMATION_DURATION } from '../PopupContent/PopupContent.constants';
var defaultProps = {
  onMouseEnter: function onMouseEnter() {
    return null;
  },
  onMouseLeave: function onMouseLeave() {
    return null;
  },
  maxLinksToShow: MAX_LINKS_TO_SHOW,
  initialActiveIndices: [],
  onLinkClick: function onLinkClick() {
    return null;
  },
  navigationMode: ITEM_NAVIGATION_MODE
};
export default function MasonryAccordionLinks(_ref) {
  var links = _ref.links,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    maxLinksToShow = _ref.maxLinksToShow,
    initialActiveIndices = _ref.initialActiveIndices,
    onLinkClick = _ref.onLinkClick,
    navigationMode = _ref.navigationMode;
  var _useResponsive = useResponsive(),
    isDesktop = _useResponsive.isDesktop,
    isTablet = _useResponsive.isTablet,
    isMobile = _useResponsive.isMobile;
  var _useContext = useContext(NavigationContext),
    openedDropdownMenus = _useContext.openedDropdownMenus,
    setOpenedDropdownMenus = _useContext.setOpenedDropdownMenus;
  useEffect(function () {
    if (_isEmtpy(initialActiveIndices)) {
      return;
    }
    setOpenedDropdownMenus(initialActiveIndices);
  }, []);
  function getBreakpointCols() {
    if (isMobile) {
      return BREAKPOINT_COLS[MOBILE_BREAKPOINT];
    }
    if (isTablet) {
      return BREAKPOINT_COLS[TABLET_BREAKPOINT];
    }
    return BREAKPOINT_COLS["default"];
  }
  function closeSiblingAccordions(index) {
    var breakpointColumns = getBreakpointCols();
    var targetColumn = index % breakpointColumns;
    setOpenedDropdownMenus(function (oldValues) {
      return oldValues.filter(function (i) {
        return i % breakpointColumns !== targetColumn;
      });
    });
  }
  function onDropdownToggle(index) {
    setOpenedDropdownMenus(function (oldValues) {
      var opened = !openedDropdownMenus.includes(index);
      if (!opened) {
        return oldValues.filter(function (value) {
          return value !== index;
        });
      }
      return [].concat(_toConsumableArray(oldValues), [index]);
    });
  }
  function onAccordionHeaderToggle(index) {
    closeSiblingAccordions(index);
    onDropdownToggle(index);
  }
  return /*#__PURE__*/React.createElement(Masonry, {
    className: "ui grid stacking doubling popup-content masonry",
    breakpointCols: BREAKPOINT_COLS,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    columnClassName: "column"
  }, links.map(function (link, index) {
    var title = link.title,
      url = link.url,
      slug = link.slug;
    var key = generateKey(title, url, slug);
    var delay = getDelay(index, isDesktop);
    return /*#__PURE__*/React.createElement(SlideReveal, {
      className: "content",
      direction: "down",
      duration: ACCORDION_REVEAL_ANIMATION_DURATION,
      delay: delay,
      fade: true,
      distance: "16px",
      key: key,
      triggerOnce: true
    }, /*#__PURE__*/React.createElement(AccordionLinks, {
      link: link,
      maxLinksToShow: maxLinksToShow,
      onLinkClick: onLinkClick,
      active: openedDropdownMenus.includes(index),
      navigationMode: navigationMode,
      onToggle: function onToggle() {
        return onAccordionHeaderToggle(index);
      }
    }));
  }));
}
MasonryAccordionLinks.defaultProps = defaultProps;